import { iBackupTactics } from '@/interface/backup-tactics';
import request from '@/utils/request';

/* 节点列表 */
export const getAreaBackList = (params?: any) =>
  request({
    url: '/api/v1/omc/area_backup',
    method: 'get',
    params,
  });

/* 策略分页 */
export const getBackupList = (params?: any) =>
  request({
    url: '/api/v1/omc/policy/backup/config/page_list',
    method: 'get',
    params,
  });

/**
 * 添加策略
 * @param params
 */
export const createBackupConfig = (params: iBackupTactics): Promise<any> =>
  request({
    data: params,
    url: '/api/v1/omc/policy/backup/config',
    method: 'post',
  });

/**
 * 修改策略
 * @param params
 */
export const updateBackupConfig = (params: iBackupTactics): Promise<any> =>
  request({
    data: params,
    url: '/api/v1/omc/policy/backup/config',
    method: 'put',
  });

export const delBackupByID = (params: any): Promise<any> =>
  request({
    data: params,
    url: '/api/v1/omc/policy/backup/config',
    method: 'DELETE',
  });

/* 策略详情 */

/**
 * 撤单反馈处理
 * @param params 参数
 */
export const getBackupDetail = (id: number): Promise<any> =>
  request({
    url: `/api/v1/omc/policy/backup/config/detail?id=${id}`,
    method: 'get',
  });

/**
 * 备机下拉类别
 * @param params 参数
 */
export const getBackupSelectList = (): Promise<any> =>
  request({
    url: `/api/v1/omc/policy/backup/config/list`,
    method: 'get',
  });

/* 节点列表更改备机名称 */

export const updateBackupBatchBind = (params: any): Promise<any> =>
  request({
    data: params,
    url: '/api/v1/omc/policy/backup/config/batch/bind',
    method: 'put',
  });
